import { BrowserModule } from "@angular/platform-browser";
import { NgModule, APP_INITIALIZER } from "@angular/core";
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { RouterModule } from "@angular/router";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { AppComponent } from "./app.component";
import { AppConfigService } from "./services/config.service";
import { CallbackComponent } from "./callback/callback.component";
import { ProtectedComponent } from "./modules/pages/protected/protected.component";
import { GettingStartedComponent } from "./modules/pages/experiences/getting-started/getting-started.component";
import { NavigationComponent } from "./modules/components/navigation/navigation.component";
import { ImageCropperComponent } from "./modules/pages/experiences/experiences-steps/images-step/image-cropper/image-cropper.component";
import { NgxFileDropModule } from "ngx-file-drop";
import { Interceptor } from "./services/http-interceptor.service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ExperienceListingComponent } from "./modules/pages/experiences/experience-listing/experience-listing.component";
import { SavingEmitterService } from "./services/emitters/saving-emitter.service";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ErrorScreenComponent } from "./modules/pages/error-screen/error-screen.component";
import { ImportExperiencesComponent } from "./modules/pages/experiences/import-experiences/import-experiences.component";
import { CreationPathComponent } from "./modules/pages/experiences/creation-path/creation-path.component";
import { ExperienceLocationComponent } from "./modules/pages/experiences/experiences-steps/location-step/experience-location/experience-location.component";
import { CustomDatepickerI18n, I18n } from "./common/datepicker-i18n";
import { CommonModule } from "@angular/common";
import { OrganizationsSidebarComponent } from "./modules/components/organizations-sidebar/organizations-sidebar.component";
import { SettingsComponent } from "./modules/pages/settings/settings.component";
import { MembersComponent } from "./modules/pages/members/members.component";
import { QrCodesComponent } from "./modules/pages/qr-codes/qr-codes.component";
import { DatepickerComponent } from "./modules/components/datepicker/datepicker.component";
import { ExperiencesStepsComponent } from "./modules/pages/experiences/experiences-steps/experiences-steps.component";
import { CompleteComponent } from "./modules/pages/experiences/experiences-steps/complete/complete.component";
import { GeneralInformationStepComponent } from "./modules/pages/experiences/experiences-steps/general-information-step/general-information-step.component";
import { LocationStepComponent } from "./modules/pages/experiences/experiences-steps/location-step/location-step.component";
import { ImagesStepComponent } from "./modules/pages/experiences/experiences-steps/images-step/images-step.component";
import { FinishingTouchesStepComponent } from "./modules/pages/experiences/experiences-steps/finishing-touches-step/finishing-touches-step.component";
import { StepsComponent } from "./modules/pages/experiences/experiences-steps/steps/steps.component";
import { AppRoutingModule } from "./app.router";
import { 
  NgbDatepickerModule,
  NgbDateAdapter,
  NgbDateNativeUTCAdapter,
  NgbTimepickerModule,
  NgbDatepickerI18n, 
  NgbModule 
} from '@ng-bootstrap/ng-bootstrap';
import { AuthConfigModule } from './auth/auth-config.module';
import { GoogleMapsComponent } from "./modules/components/google-maps/google-maps.component";
import { RetryHttpErrorsInterceptor } from "@services/http-retry-interceptor.service";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({ declarations: [
        AppComponent,
        CallbackComponent,
        ProtectedComponent,
        GettingStartedComponent,
        NavigationComponent,
        ImageCropperComponent,
        ExperienceListingComponent,
        ErrorScreenComponent,
        ImportExperiencesComponent,
        CreationPathComponent,
        ExperienceLocationComponent,
        OrganizationsSidebarComponent,
        SettingsComponent,
        MembersComponent,
        QrCodesComponent,
        DatepickerComponent,
        ExperiencesStepsComponent,
        CompleteComponent,
        GeneralInformationStepComponent,
        LocationStepComponent,
        ImagesStepComponent,
        FinishingTouchesStepComponent,
        StepsComponent
    ],
    bootstrap: [AppComponent], 
    imports: [
    BrowserModule,
    AppRoutingModule,
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    NgxFileDropModule,
    BrowserAnimationsModule,
    NgbModule,
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient],
        },
    }),
    AuthConfigModule,
    GoogleMapsComponent
], providers: [
        AppConfigService,
        {
            provide: APP_INITIALIZER,
            useFactory: AppConfigService.initializer,
            multi: true,
            deps: [AppConfigService],
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: Interceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RetryHttpErrorsInterceptor,
            multi: true,
        },
        I18n,
        { provide: NgbDateAdapter, useClass: NgbDateNativeUTCAdapter },
        { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
        ImageCropperComponent,
        SavingEmitterService,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
